<template>
	<div class="password">
		<infoHeader :title="title" icon="el-icon-lock"></infoHeader>
		<div class="fixation">
			<el-steps :active="active" simple>
				<el-step title="选择验证方式" icon="el-icon-edit"></el-step>
				<el-step title="输入新密码" icon="el-icon-phone"></el-step>
				<el-step title="修改成功" icon="el-icon-check"></el-step>
			</el-steps>
			<div class="form" v-if="active == 0">
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="120px">
					<div class="welcome">
						选择验证方式
					</div>
					<el-form-item label="验证方式" prop="type">
						<el-select v-model="ruleForm.type" placeholder="请选择验证方式">
							<el-option v-for="(item,index) in typeList" :key="index" :value="item.value"
								:label="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="手机号" prop="phone" v-if="ruleForm.type==1" :rules="[{required: ruleForm.type == 1,
							trigger: 'blur',validator: verify_phone}]">
						<el-input type="text" v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
					</el-form-item>
					<el-form-item label="邮箱" prop="email" v-if="ruleForm.type==2" :rules="[{required: ruleForm.type == 2,
							trigger: 'blur', message:'请输入邮箱'}]">
						<el-input type="text" v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
					</el-form-item>
					<el-form-item label="验证码" prop="code">
						<el-input type="text" v-model="ruleForm.code" placeholder="请输入验证码">
							<el-button slot="append" :disabled="disabled" :loading="loading" @click="sendCode">
								<span v-if="!disabled">发送{{ruleForm.type==1?'短信':'邮箱'}}验证码</span>
								<span v-else>{{second}}秒后可重发</span>
							</el-button>
						</el-input>
					</el-form-item>
					<el-form-item>
						<div class="dialog-button">
							<el-button type="danger" @click="submitForm('ruleForm')">下一步</el-button>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div class="form" v-if="active == 1">
				<el-form :model="newForm" :rules="newRule" ref="newForm" label-width="120px">
					<div class="welcome">
						设置新邮箱
					</div>
					<el-form-item label="新密码" prop="password">
						<el-input type="text" v-model="newForm.password" placeholder="请输入新密码"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="rptpassword">
						<el-input type="text" v-model="newForm.rptpassword" placeholder="请确认密码"></el-input>
					</el-form-item>
					<el-form-item>
						<div class="dialog-button">
							<el-button type="danger" @click="submitForm('newForm')">下一步</el-button>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div class="result" v-if="active == 2">
				<el-result icon="success" title="修改成功" subTitle="请点击按钮返回首页或重新登录">
					<template slot="extra">
						<el-button type="danger" plain size="medium" @click="goIndex">返回首页</el-button>
						<el-button type="danger" plain size="medium" @click="doLogin">重新登录</el-button>
					</template>
				</el-result>
			</div>
		</div>
		<pubfooter></pubfooter>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'password',
		data() {
			let verify_phone = (rule, value, callback) => {
				if (!this.$ver.verify_phone(this.ruleForm.phone)) {
					callback(new Error('手机号格式错误'))
				} else {
					callback()
				}
			}
			let verify_email = (rule, value, callback) => {
				if (!this.$ver.verify_email(this.ruleForm.email)) {
					callback(new Error('邮箱格式错误'))
				} else {
					callback()
				}
			}
			let verify_password = (rule, value, callback) => {
				if (!this.$ver.verify_password(this.ruleForm.password)) {
					callback(new Error('请输入6-18位密码'))
				} else {
					callback()
				}
			}
			let verify_rptpassword = (rule, value, callback) => {
				if (!this.$ver.verify_password(this.ruleForm.rptpassword)) {
					callback(new Error('请输入6-18位密码'))
				} else if (this.ruleForm.password != this.ruleForm.rptpassword) {
					callback(new Error('两次输入的密码不一致'))
				} else {
					callback()
				}
			}
			return {
				title: '修改密码',
				active: 0,
				typeList: [{
						value: 1,
						label: '手机号码验证'
					},
					{
						value: 2,
						label: '邮箱验证'
					}
				],
				ruleForm: {
					type: 1,
					phone: '',
					email: '',
					code: ''
				},
				rule: {
					type: [{
						required: true,
						trigger: 'change',
						message: '请选择验证方式'
					}],
					code: [{
						required: true,
						trigger: 'blur',
						message: '请输入短信验证码'
					}]
				},
				verify_phone: verify_phone,
				verify_email: verify_email,
				disabled: false,
				newForm: {
					password: '',
					rptpassword: ''
				},
				newRule: {
					password: [{
						required: true,
						trigger: 'blur',
						validator: verify_password
					}],
					rptpassword: [{
						required: true,
						trigger: 'blur',
						validator: verify_rptpassword
					}],
				},
				loading: false,
				second: 60
			};
		},
		methods: {
			...mapMutations(['login', 'saveUserinfo', 'logout']),
			sendCode() {
				if (this.disabled) return
				if (this.ruleForm.type == 1) {
					let data = {
						userId: this.$store.state.userinfo.userId,
						username: ''
					}
					if (this.active == 0) {
						data['phone'] = this.ruleForm.phone
						data['scence'] = 1
					} else {
						data['phone'] = this.newForm.phone
						data['scence'] = 0
					}
					this.loading = true
					this.$api.frontSendMsg(data, res => {
						this.loading = false
						if (res.code == 200) {
							this.$message({
								message: '短信验证码发送成功。',
								type: 'success',
								duration: 2000
							})
							this.timer()
						}
					})
				} else {
					this.loading = true
					this.$api.frontSendEmail({
						email: this.ruleForm.email,
						scence: 1,
						userId: this.$store.state.userinfo.userId,
						username: ''
					}, res => {
						this.loading = false
						if (res.code == 200) {
							this.$message({
								message: '邮箱验证码发送成功。',
								type: 'success',
								duration: 2000
							})
							this.timer()
						}
					})
				}
			},
			timer() {
				this.disabled = true
				this.$pub.timer(this.second, res => {
					this.second = res
					if (res == 0) {
						this.second = 60
						this.disabled = false
					}
				})
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (formName === 'ruleForm') {
							//验证
							let data = {
								code: this.ruleForm.code,
								codeType: this.ruleForm.type,
								userId: this.$store.state.userinfo.userId
							}
							if (this.ruleForm.type == 1) {
								data['phone'] = this.ruleForm.phone
								this.loading = true
								this.$api.frontPhoneVerify(data, res => {
									if (res.code == 200) {
										this.loading = false
										this.next()
									}
								})
							} else {
								data['email'] = this.ruleForm.email
								this.loading = true
								this.$api.frontEmailVerify(data, res => {
									if (res.code == 200) {
										this.loading = false
										this.next()
									}
								})
							}
						}
						if (formName === 'newForm') {
							this.loading = true
							this.$api.frontPasswordEdit({
								pwd: this.newForm.password,
								rePassword: this.newForm.rptpassword,
								userId: this.$store.state.userinfo.userId
							}, res => {
								this.loading = false
								if (res.code == 200) {
									this.active = 2
								}
							})
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			next() {
				this.$message({
					type: 'success',
					duration: 2000,
					message: '验证成功',
					onClose: () => {
						this.active = 1
					}
				})
			},
			goIndex() {
				this.logout()
			},
			doLogin() {
				this.$api.frontLogin({
					username: this.ruleForm.type == 1 ? this.ruleForm.phone : this.ruleForm.email,
					pwd: this.newForm.password
				}, res => {
					if (res.code == 200) {
						this.saveUserinfo(res.data.systemUser)
						this.login(res.data.token)
						this.$message({
							message: '登录成功，返回个人中心。',
							type: 'success',
							duration: 2000,
							onClose: () => {
								this.goSpace()
							}
						})
					}
				})
			},
			goSpace() {
				this.$router.push({
					path: '/setting'
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.fixation {
		margin-top: @vue-spacing-col-lg*3;
	}

	.form,
	.result {
		width: 100%;
		margin-top: @vue-spacing-col-lg*2;
	}

	.form {
		border: 1px solid @vue-border-color-red;
		padding: @vue-spacing-col-lg @vue-spacing-row-lg*6;
		box-sizing: border-box;
		border-radius: @vue-border-radius-lg * 2;

		.el-select {
			width: 100%;
		}
	}

	.welcome {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		font-size: @vue-font-size-base;
		color: @vue-text-color-red;
		margin-bottom: @vue-spacing-col-lg;
	}
</style>
